module.exports = __webpack_public_path__ + "images/vector/app/web/src/assets/primary icon-dfd4479f.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/primary icon.svg
// module id = ./app/web/src/assets/primary icon.svg
// module chunks = 0